// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the entire A4 page */
.a4-container {
    width: 210mm;  /* A4 width */
    height: auto; /* A4 height */
    margin: auto; /* Center the content */
    padding: 15mm;  /* Padding inside the A4 container */
    box-sizing: border-box;
    background-color: #fff;  /* Optional, for better visual appearance */
    border: 1px solid white;
}

/* Content inside the A4 container */
.tracking-content {
    width: 100%;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    padding: 0;
}
.tracking-header{
    margin-top: 0; /* Fixed from -50px to make header visible */
    text-align: center;
}
.tracking-header-text{
    margin-top: -5px;
    font-size: 12px;
}
.tracking-header-bold{
    margin-top: -5px;
    margin-bottom: -5px;
    font-size: 15px;
}
.application-title{
    text-align: center;
}

.tracking-date{
    text-align: end;
    font-size: 12px;
}

.tracking-greetings p{
    margin-top: -0px;
    font-size: 14px;
}
.indent-first-line {
    text-indent: 50px; /* Adjust the indentation as needed */
    font-size: 14px;
    text-align: justify;
}
.bold-span{
    font-weight: bold;
    text-decoration: underline;
}
.single-row {
    display: grid;
    grid-template-columns: 1fr 2fr; /* Two columns for label-value pairs */
    align-items: center; /* Vertically center the items in each row */
}
.single-row2 {
    display: grid;
    grid-template-columns: 1fr 1fr; /* Two columns for label-value pairs */
    align-items: center; /* Vertically center the items in each row */
    margin-top: -0px;
    margin-bottom: -0px;
}
.single-row3 {
    display: flex;
    align-items: flex-end; /* Vertically center the items in each row */
    width: 90%;
    flex-direction: column;
}

.single-row p:first-child {
    font-weight: bold; /* Make the label bold */
    margin-right: -50px;
}

.full-span {
    display: flex;
    flex-direction: column;
    align-self: flex-end;
    justify-self: flex-end;
    margin-top: 20px;
    margin-right: 30px;
}

/* Optional: Add padding or margin for better spacing */
.single-row p {
    margin: 0;
    padding: 0;
}

/* Handle overflow or long content */
.single-row p {
    word-break: break-word; /* Ensure text breaks correctly if too long */
}
.json-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.json-table th, .json-table td {
    border: 1px solid #ddd;
    padding: 2px;
    text-align: left;
    font-size: 13px;
}

/* Fixed: Made the registration columns properly align */
.registration-header {
    text-align: center;
    border-bottom: 1px solid #ddd;
    margin: 0;
    padding: 2px;
}

.registration-columns {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
}

.registration-columns p {
    flex: 1 1;
    text-align: center;
    margin: 0;
    padding: 4px 0;
}

/* Add space above notary signature line */
.notary-signature {
    margin-top: 30px;
    text-align: center;
}

.buttoncontainerzz{
   display: flex;
   flex-direction: column; 
   position: fixed; 
   bottom: 0; 
   right: 20px;
   z-index: 1000;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .popup-content {
    background: white;
    padding: 20px;
    width: 90%;
    max-width: 400px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .drop-area {
    border: 2px dashed #007bff;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    color: #007bff;
    background-color: #f8f9fa;
    cursor: pointer;
  }
  
  .drop-area:hover {
    background-color: #e9ecef;
  }
  
  .file-list {
    margin-top: 15px;
    max-height: 150px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    padding: 10px;
    background-color: #f8f9fa;
  }
  
  .file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    padding: 5px;
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 5px;
  }
  
  .file-item button {
    background-color: #dc3545;
    color: white;
    font-size: 14px;
    padding: 5px 10px;
  }
  
  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }


/* Reusable row layout */
/* Media query for mobile devices */
@media (max-width: 768px) {
    .a4-container {
        transform: scale(1); /* Scale down to 25% */
        transform-origin: top left; /* Set the origin for scaling */
        width: auto; /* Reset width to auto */
        height: auto; /* Reset height to auto */
        margin: 0; /* Remove margin to avoid overflow */
        padding: 5mm; /* Adjust padding as needed */
        margin-top: 50px;
    }
    .popup-content {
        width: 95%;
      }
    
      button {
        font-size: 14px;
        padding: 8px 12px;
      }
    
      .drop-area {
        font-size: 14px;
        padding: 15px;
      }
    
      .file-item {
        font-size: 14px;
        padding: 5px;
      }
}

/* Style for printing - FIXED to prevent duplication */
@media print {
    /* Reset any background colors and borders for printing */
    @page {
        size: A4 portrait;
        margin: 0.4cm;
        margin-bottom: 0.3cm; /* Smaller bottom margin to fit more content */
    }
    
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    body, html {
        background-color: white !important;
        margin: 0 !important;
        padding: 0 !important;
        height: auto !important;
        width: 100% !important;
        overflow: visible !important;
    }
    
    /* Prevent duplication by removing position: relative */
    body > div {
        background-color: white !important;
        height: auto !important;
        overflow: visible !important;
    }

    .a4-container {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 3mm !important;
        box-sizing: border-box !important;
        border: none !important;
        overflow: visible !important;
        box-shadow: none !important;
        transform: none !important;
        float: none !important;
        page-break-after: auto !important;
        display: block !important;
    }

    /* Print-specific adjustments */
    .tracking-content {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        display: block !important;
        page-break-after: avoid !important;
        page-break-before: avoid !important;
        float: none !important;
    }

    /* Further reduce font sizes for everything */
    /* * {
        font-size: 8pt !important;
    } */

    /* Improve text display in print */
    p, h1, h2, h3, h4, h5, h6 {
        orphans: 3 !important;
        widows: 3 !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        margin-bottom: 2px !important;
        margin-top: 2px !important;
        line-height: 1.2 !important;
    }

    /* Ensure proper page breaks */
    .tablediv {
        page-break-inside: auto !important; /* Allow page breaks inside table sections when needed */
        margin-bottom: 10px !important;
        display: block !important;
        clear: both !important;
    }
    
    /* Ensure tables break properly */
    .json-table {
        width: 100% !important;
        border-collapse: collapse !important;
        table-layout: fixed !important;
        page-break-inside: auto !important;
        break-inside: auto !important;
        font-size: 8pt !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }

    .json-table th, .json-table td {
        border: 0.5px solid #000 !important; /* Thinner borders for better printing */
        padding: 1px !important;
        word-wrap: break-word !important;
        font-size: 8pt !important; /* Smaller font for tables to fit better */
        max-width: 100% !important;
    }
    
    /* Make Department header visible in print */
    .tracking-header {
        margin-top: 0 !important;
    }
    
    .tracking-header-text {
        margin-top: -2px !important;
        font-size: 7pt !important;
        visibility: visible !important;
        display: block !important;
    }
    
    .tracking-header-bold {
        margin-top: -2px !important;
        margin-bottom: -2px !important;
        font-size: 10pt !important;
    }
    
    .application-title {
        font-size: 11pt !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }
    
    /* Hide anything not needed for printing */
    .buttoncontainerzz,
    .popup-overlay,
    button {
        display: none !important;
    }
    
    /* Ensure columns display properly in print */
    .single-row, .single-row2 {
        display: grid !important;
        width: 100% !important;
    }
    
    /* Fix font sizes for printing */
    .tracking-content {
        font-size: 7pt !important;
        line-height: 1.1 !important;
    }
    
    /* Compress vertical spacing to fit more content */
    .tracking-greetings p {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        font-size: 7pt !important;
        line-height: 1.1 !important;
    }
    
    /* Make sure the bottom content fits */
    .single-row3 {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-end !important;
        width: 100% !important;
        margin-bottom: 0px !important;
        margin-top: 20px !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
    }
    
    /* Add space above notary signature line in print */
    .notary-signature {
        margin-top: 20px !important;
    }
    
    /* Target the very last lines specifically */
    .tracking-content > div:last-of-type {
        display: block !important;
        break-inside: avoid !important;
        page-break-inside: avoid !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
    
    /* Specifically target the final four lines */
    .tracking-content > div:last-of-type > p:nth-last-child(-n+4) {
        display: block !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        line-height: 1.1 !important;
        font-size: 7pt !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/TrackingDocument/TrackingDocument.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,YAAY,GAAG,aAAa;IAC5B,YAAY,EAAE,cAAc;IAC5B,YAAY,EAAE,uBAAuB;IACrC,aAAa,GAAG,oCAAoC;IACpD,sBAAsB;IACtB,sBAAsB,GAAG,2CAA2C;IACpE,uBAAuB;AAC3B;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa,EAAE,4CAA4C;IAC3D,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,iBAAiB,EAAE,qCAAqC;IACxD,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,8BAA8B,EAAE,sCAAsC;IACtE,mBAAmB,EAAE,4CAA4C;AACrE;AACA;IACI,aAAa;IACb,8BAA8B,EAAE,sCAAsC;IACtE,mBAAmB,EAAE,4CAA4C;IACjE,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,qBAAqB,EAAE,4CAA4C;IACnE,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB,EAAE,wBAAwB;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,uDAAuD;AACvD;IACI,SAAS;IACT,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,sBAAsB,EAAE,6CAA6C;AACzE;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA,wDAAwD;AACxD;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,SAAS;IACT,cAAc;AAClB;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,eAAe;GACf,SAAS;GACT,WAAW;GACX,aAAa;AAChB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;;AAGF,wBAAwB;AACxB,mCAAmC;AACnC;IACI;QACI,mBAAmB,EAAE,sBAAsB;QAC3C,0BAA0B,EAAE,+BAA+B;QAC3D,WAAW,EAAE,wBAAwB;QACrC,YAAY,EAAE,yBAAyB;QACvC,SAAS,EAAE,oCAAoC;QAC/C,YAAY,EAAE,6BAA6B;QAC3C,gBAAgB;IACpB;IACA;QACI,UAAU;MACZ;;MAEA;QACE,eAAe;QACf,iBAAiB;MACnB;;MAEA;QACE,eAAe;QACf,aAAa;MACf;;MAEA;QACE,eAAe;QACf,YAAY;MACd;AACN;;AAEA,sDAAsD;AACtD;IACI,yDAAyD;IACzD;QACI,iBAAiB;QACjB,aAAa;QACb,oBAAoB,EAAE,8CAA8C;IACxE;;IAEA;QACI,4CAA4C;QAE5C,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;QAClC,oBAAoB;QACpB,qBAAqB;QACrB,uBAAuB;QACvB,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA,uDAAuD;IACvD;QACI,kCAAkC;QAClC,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;QACpB,uBAAuB;QACvB,iCAAiC;QACjC,uBAAuB;QACvB,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;QAC1B,sBAAsB;QACtB,iCAAiC;QACjC,yBAAyB;IAC7B;;IAEA,+BAA+B;IAC/B;QACI,sBAAsB;QACtB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,yBAAyB;QACzB,kCAAkC;QAClC,mCAAmC;QACnC,sBAAsB;IAC1B;;IAEA,6CAA6C;IAC7C;;OAEG;;IAEH,kCAAkC;IAClC;QACI,qBAAqB;QACrB,oBAAoB;QACpB,mCAAmC;QACnC,8BAA8B;QAC9B,6BAA6B;QAC7B,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA,8BAA8B;IAC9B;QACI,kCAAkC,EAAE,wDAAwD;QAC5F,8BAA8B;QAC9B,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA,iCAAiC;IACjC;QACI,sBAAsB;QACtB,oCAAoC;QACpC,8BAA8B;QAC9B,kCAAkC;QAClC,6BAA6B;QAC7B,yBAAyB;QACzB,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,mCAAmC,EAAE,wCAAwC;QAC7E,uBAAuB;QACvB,gCAAgC;QAChC,yBAAyB,EAAE,0CAA0C;QACrE,0BAA0B;IAC9B;;IAEA,4CAA4C;IAC5C;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,yBAAyB;QACzB,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA,0CAA0C;IAC1C;;;QAGI,wBAAwB;IAC5B;;IAEA,6CAA6C;IAC7C;QACI,wBAAwB;QACxB,sBAAsB;IAC1B;;IAEA,gCAAgC;IAChC;QACI,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA,kDAAkD;IAClD;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA,sCAAsC;IACtC;QACI,wBAAwB;QACxB,iCAAiC;QACjC,gCAAgC;QAChC,sBAAsB;QACtB,6BAA6B;QAC7B,2BAA2B;QAC3B,mCAA8B;QAA9B,8BAA8B;IAClC;;IAEA,mDAAmD;IACnD;QACI,2BAA2B;IAC/B;;IAEA,4CAA4C;IAC5C;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,mCAAmC;QACnC,wBAAwB;QACxB,2BAA2B;QAC3B,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA,6CAA6C;IAC7C;QACI,yBAAyB;QACzB,wBAAwB;QACxB,2BAA2B;QAC3B,yBAAyB;QACzB,4BAA4B;QAC5B,2BAA2B;QAC3B,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Container for the entire A4 page */\r\n.a4-container {\r\n    width: 210mm;  /* A4 width */\r\n    height: auto; /* A4 height */\r\n    margin: auto; /* Center the content */\r\n    padding: 15mm;  /* Padding inside the A4 container */\r\n    box-sizing: border-box;\r\n    background-color: #fff;  /* Optional, for better visual appearance */\r\n    border: 1px solid white;\r\n}\r\n\r\n/* Content inside the A4 container */\r\n.tracking-content {\r\n    width: 100%;\r\n    font-family: Arial, sans-serif;\r\n    line-height: 1.6;\r\n    padding: 0;\r\n}\r\n.tracking-header{\r\n    margin-top: 0; /* Fixed from -50px to make header visible */\r\n    text-align: center;\r\n}\r\n.tracking-header-text{\r\n    margin-top: -5px;\r\n    font-size: 12px;\r\n}\r\n.tracking-header-bold{\r\n    margin-top: -5px;\r\n    margin-bottom: -5px;\r\n    font-size: 15px;\r\n}\r\n.application-title{\r\n    text-align: center;\r\n}\r\n\r\n.tracking-date{\r\n    text-align: end;\r\n    font-size: 12px;\r\n}\r\n\r\n.tracking-greetings p{\r\n    margin-top: -0px;\r\n    font-size: 14px;\r\n}\r\n.indent-first-line {\r\n    text-indent: 50px; /* Adjust the indentation as needed */\r\n    font-size: 14px;\r\n    text-align: justify;\r\n}\r\n.bold-span{\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n}\r\n.single-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr; /* Two columns for label-value pairs */\r\n    align-items: center; /* Vertically center the items in each row */\r\n}\r\n.single-row2 {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr; /* Two columns for label-value pairs */\r\n    align-items: center; /* Vertically center the items in each row */\r\n    margin-top: -0px;\r\n    margin-bottom: -0px;\r\n}\r\n.single-row3 {\r\n    display: flex;\r\n    align-items: flex-end; /* Vertically center the items in each row */\r\n    width: 90%;\r\n    flex-direction: column;\r\n}\r\n\r\n.single-row p:first-child {\r\n    font-weight: bold; /* Make the label bold */\r\n    margin-right: -50px;\r\n}\r\n\r\n.full-span {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: flex-end;\r\n    justify-self: flex-end;\r\n    margin-top: 20px;\r\n    margin-right: 30px;\r\n}\r\n\r\n/* Optional: Add padding or margin for better spacing */\r\n.single-row p {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n/* Handle overflow or long content */\r\n.single-row p {\r\n    word-break: break-word; /* Ensure text breaks correctly if too long */\r\n}\r\n.json-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n}\r\n\r\n.json-table th, .json-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 2px;\r\n    text-align: left;\r\n    font-size: 13px;\r\n}\r\n\r\n/* Fixed: Made the registration columns properly align */\r\n.registration-header {\r\n    text-align: center;\r\n    border-bottom: 1px solid #ddd;\r\n    margin: 0;\r\n    padding: 2px;\r\n}\r\n\r\n.registration-columns {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.registration-columns p {\r\n    flex: 1;\r\n    text-align: center;\r\n    margin: 0;\r\n    padding: 4px 0;\r\n}\r\n\r\n/* Add space above notary signature line */\r\n.notary-signature {\r\n    margin-top: 30px;\r\n    text-align: center;\r\n}\r\n\r\n.buttoncontainerzz{\r\n   display: flex;\r\n   flex-direction: column; \r\n   position: fixed; \r\n   bottom: 0; \r\n   right: 20px;\r\n   z-index: 1000;\r\n}\r\n\r\n.popup-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .popup-content {\r\n    background: white;\r\n    padding: 20px;\r\n    width: 90%;\r\n    max-width: 400px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .drop-area {\r\n    border: 2px dashed #007bff;\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    text-align: center;\r\n    color: #007bff;\r\n    background-color: #f8f9fa;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .drop-area:hover {\r\n    background-color: #e9ecef;\r\n  }\r\n  \r\n  .file-list {\r\n    margin-top: 15px;\r\n    max-height: 150px;\r\n    overflow-y: auto;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 5px;\r\n    padding: 10px;\r\n    background-color: #f8f9fa;\r\n  }\r\n  \r\n  .file-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 5px;\r\n    padding: 5px;\r\n    background: #ffffff;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .file-item button {\r\n    background-color: #dc3545;\r\n    color: white;\r\n    font-size: 14px;\r\n    padding: 5px 10px;\r\n  }\r\n  \r\n  .actions {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 15px;\r\n  }\r\n\r\n\r\n/* Reusable row layout */\r\n/* Media query for mobile devices */\r\n@media (max-width: 768px) {\r\n    .a4-container {\r\n        transform: scale(1); /* Scale down to 25% */\r\n        transform-origin: top left; /* Set the origin for scaling */\r\n        width: auto; /* Reset width to auto */\r\n        height: auto; /* Reset height to auto */\r\n        margin: 0; /* Remove margin to avoid overflow */\r\n        padding: 5mm; /* Adjust padding as needed */\r\n        margin-top: 50px;\r\n    }\r\n    .popup-content {\r\n        width: 95%;\r\n      }\r\n    \r\n      button {\r\n        font-size: 14px;\r\n        padding: 8px 12px;\r\n      }\r\n    \r\n      .drop-area {\r\n        font-size: 14px;\r\n        padding: 15px;\r\n      }\r\n    \r\n      .file-item {\r\n        font-size: 14px;\r\n        padding: 5px;\r\n      }\r\n}\r\n\r\n/* Style for printing - FIXED to prevent duplication */\r\n@media print {\r\n    /* Reset any background colors and borders for printing */\r\n    @page {\r\n        size: A4 portrait;\r\n        margin: 0.4cm;\r\n        margin-bottom: 0.3cm; /* Smaller bottom margin to fit more content */\r\n    }\r\n    \r\n    * {\r\n        -webkit-print-color-adjust: exact !important;\r\n        color-adjust: exact !important;\r\n        print-color-adjust: exact !important;\r\n    }\r\n    \r\n    body, html {\r\n        background-color: white !important;\r\n        margin: 0 !important;\r\n        padding: 0 !important;\r\n        height: auto !important;\r\n        width: 100% !important;\r\n        overflow: visible !important;\r\n    }\r\n    \r\n    /* Prevent duplication by removing position: relative */\r\n    body > div {\r\n        background-color: white !important;\r\n        height: auto !important;\r\n        overflow: visible !important;\r\n    }\r\n\r\n    .a4-container {\r\n        width: 100% !important;\r\n        height: auto !important;\r\n        margin: 0 !important;\r\n        padding: 3mm !important;\r\n        box-sizing: border-box !important;\r\n        border: none !important;\r\n        overflow: visible !important;\r\n        box-shadow: none !important;\r\n        transform: none !important;\r\n        float: none !important;\r\n        page-break-after: auto !important;\r\n        display: block !important;\r\n    }\r\n\r\n    /* Print-specific adjustments */\r\n    .tracking-content {\r\n        width: 100% !important;\r\n        margin: 0 !important;\r\n        padding: 0 !important;\r\n        overflow: visible !important;\r\n        display: block !important;\r\n        page-break-after: avoid !important;\r\n        page-break-before: avoid !important;\r\n        float: none !important;\r\n    }\r\n\r\n    /* Further reduce font sizes for everything */\r\n    /* * {\r\n        font-size: 8pt !important;\r\n    } */\r\n\r\n    /* Improve text display in print */\r\n    p, h1, h2, h3, h4, h5, h6 {\r\n        orphans: 3 !important;\r\n        widows: 3 !important;\r\n        page-break-inside: avoid !important;\r\n        break-inside: avoid !important;\r\n        margin-bottom: 2px !important;\r\n        margin-top: 2px !important;\r\n        line-height: 1.2 !important;\r\n    }\r\n\r\n    /* Ensure proper page breaks */\r\n    .tablediv {\r\n        page-break-inside: auto !important; /* Allow page breaks inside table sections when needed */\r\n        margin-bottom: 10px !important;\r\n        display: block !important;\r\n        clear: both !important;\r\n    }\r\n    \r\n    /* Ensure tables break properly */\r\n    .json-table {\r\n        width: 100% !important;\r\n        border-collapse: collapse !important;\r\n        table-layout: fixed !important;\r\n        page-break-inside: auto !important;\r\n        break-inside: auto !important;\r\n        font-size: 8pt !important;\r\n        margin-top: 5px !important;\r\n        margin-bottom: 5px !important;\r\n    }\r\n\r\n    .json-table th, .json-table td {\r\n        border: 0.5px solid #000 !important; /* Thinner borders for better printing */\r\n        padding: 1px !important;\r\n        word-wrap: break-word !important;\r\n        font-size: 8pt !important; /* Smaller font for tables to fit better */\r\n        max-width: 100% !important;\r\n    }\r\n    \r\n    /* Make Department header visible in print */\r\n    .tracking-header {\r\n        margin-top: 0 !important;\r\n    }\r\n    \r\n    .tracking-header-text {\r\n        margin-top: -2px !important;\r\n        font-size: 7pt !important;\r\n        visibility: visible !important;\r\n        display: block !important;\r\n    }\r\n    \r\n    .tracking-header-bold {\r\n        margin-top: -2px !important;\r\n        margin-bottom: -2px !important;\r\n        font-size: 10pt !important;\r\n    }\r\n    \r\n    .application-title {\r\n        font-size: 11pt !important;\r\n        margin-top: 5px !important;\r\n        margin-bottom: 5px !important;\r\n    }\r\n    \r\n    /* Hide anything not needed for printing */\r\n    .buttoncontainerzz,\r\n    .popup-overlay,\r\n    button {\r\n        display: none !important;\r\n    }\r\n    \r\n    /* Ensure columns display properly in print */\r\n    .single-row, .single-row2 {\r\n        display: grid !important;\r\n        width: 100% !important;\r\n    }\r\n    \r\n    /* Fix font sizes for printing */\r\n    .tracking-content {\r\n        font-size: 7pt !important;\r\n        line-height: 1.1 !important;\r\n    }\r\n    \r\n    /* Compress vertical spacing to fit more content */\r\n    .tracking-greetings p {\r\n        margin-top: 0px !important;\r\n        margin-bottom: 0px !important;\r\n        font-size: 7pt !important;\r\n        line-height: 1.1 !important;\r\n    }\r\n    \r\n    /* Make sure the bottom content fits */\r\n    .single-row3 {\r\n        display: flex !important;\r\n        flex-direction: column !important;\r\n        align-items: flex-end !important;\r\n        width: 100% !important;\r\n        margin-bottom: 0px !important;\r\n        margin-top: 20px !important;\r\n        break-inside: avoid !important;\r\n    }\r\n    \r\n    /* Add space above notary signature line in print */\r\n    .notary-signature {\r\n        margin-top: 20px !important;\r\n    }\r\n    \r\n    /* Target the very last lines specifically */\r\n    .tracking-content > div:last-of-type {\r\n        display: block !important;\r\n        break-inside: avoid !important;\r\n        page-break-inside: avoid !important;\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important;\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important;\r\n    }\r\n    \r\n    /* Specifically target the final four lines */\r\n    .tracking-content > div:last-of-type > p:nth-last-child(-n+4) {\r\n        display: block !important;\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important;\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important;\r\n        line-height: 1.1 !important;\r\n        font-size: 7pt !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
